module.exports = __webpack_public_path__ + "static/media/jeno-4.jpeg";